import { combineReducers } from 'redux'
import { createAsyncAction, createReducer, isActionOf } from 'typesafe-actions'
import {
    StatisticsData,
    StatisticsInWork,
} from '../../../responses/statistics'
import * as O from 'fp-ts/Option'
import { Option } from 'fp-ts/Option'
import { RootEpic } from '../../root'
import { filter, map, mergeMap } from 'rxjs/operators'
import { apiRequests } from '../../../http/config'
import { toastFailedResponse } from '../../../components/controls/Toaster/Toaster'


export const byWorkActions = {
    data: createAsyncAction(
        '@STATISTICS_BY_WORK/DATA_REQUEST',
        '@STATISTICS_BY_WORK/DATA_SUCCESS',
        '@STATISTICS_BY_WORK/DATA_FAILURE',
    )<void, StatisticsData<StatisticsInWork>, void>(),
}

export interface ByWorkState {
    data: Option<StatisticsData<StatisticsInWork>>,
}

export const byWorkReducer = combineReducers<ByWorkState>({
    data: createReducer<Option<StatisticsData<StatisticsInWork>>>(O.none)
        .handleAction(byWorkActions.data.success, (_, action) => O.of(action.payload))
})

export const byWorkEpic: RootEpic = action$ => action$.pipe(
    filter(isActionOf(byWorkActions.data.request)),
    mergeMap(action => apiRequests.statistics.inWork({
        query: action.payload
    })),
    map(res => res.response.success?
        byWorkActions.data.success(res.response):
        byWorkActions.data.failure(toastFailedResponse(res.response, 'Загрузка статистики по задачам не удалась'))
    )
)